let BethistorySearchForm = {
  fromSearch: '',
  toSearch: '',

  toPayload: function() {
    return {
      fromSearch: this.fromSearch,
      toSearch: this.toSearch
    };
  }
};

export default BethistorySearchForm;



// WEBPACK FOOTER //
// ./client/app/pages/customer/bethistory/model/form.model.js